import axios from 'axios'
import { ROOT_URL } from '../utils/helpers'

import {
  CREATE_ENQUIRY_SUCCESS,
  CREATE_ENQUIRY_ERROR
} from './types'

// Create an enquiry
export function createEnquiry (data, callback) {
  let sport = window.location.pathname.split('/')[2]

  return function (dispatch) {
    const payload = {
      data
    }

    axios.post(`${ROOT_URL}/enquiries?id_package_variant=${localStorage.getItem('id_package_variant')}&sport=${sport}&id_province=${localStorage.getItem('id_province')}&duration=${localStorage.getItem('duration_selected')}`, payload)
      .then(response => {
        // If request is succesful
        // Update state with response info
        dispatch({
          type: CREATE_ENQUIRY_SUCCESS,
          payload: response.data
        })
        callback()
      })
      .catch(error => {
        // If request fails
        if (error.response) {
          const errors = error.response.data.errors
          dispatch({
            type: CREATE_ENQUIRY_ERROR,
            payload: errors
          })
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/enquiries.js